import { createStore } from "zustand/vanilla"

type NumberFormatState = {
  locale: string
}

export type NumberFormatOverride = "de-DE" | "en-US" | "browser" | ""

export function detectBrowserLocale(): string {
  if (typeof navigator === "undefined") return "de-DE"
  const lang = navigator.language
  const commaThousandSepLangs = ["en", "ja", "ko", "zh"]
  const prefix = lang.split("-")[0] ?? ""
  return commaThousandSepLangs.includes(prefix) ? "en-US" : "de-DE"
}

function resolveOverride(raw: NumberFormatOverride): string | null {
  if (raw === "browser") return detectBrowserLocale()
  if (raw === "de-DE" || raw === "en-US") return raw
  return null
}

function readStoredOverride(): string | null {
  try {
    // useSafeLocalStorage with crossCompany stores under "template-{key}"
    const raw = localStorage.getItem("template-numberFormatLocaleOverride")
    if (!raw) return null
    const parsed = JSON.parse(raw) as string
    return resolveOverride(parsed as NumberFormatOverride)
  } catch {
    return null
  }
}

export function setCompanyLocale(locale: string) {
  const override = readStoredOverride()
  numberFormatStore.setState({ locale: override ?? locale })
}

const numberFormatStore = createStore<NumberFormatState>()(() => ({
  locale: readStoredOverride() ?? "de-DE",
}))

export const getNumberFormatLocale = () => numberFormatStore.getState().locale
